import { Box } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import back_image from "../../assets/images/Memory_Card.png";
function Card({ card, onClick }) {
    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const md = useMediaQuery({ minWidth: 900 });
    const sm = useMediaQuery({ maxWidth: 767 });
    return (
        <Box
            sx={{ height: sm ? "150px" : "calc(33.333% - 10px)" }}
            className={`memory-card${card.isFlipped ? " flip" : ""}`}
            onClick={onClick}
            style={{ order: card.order }}
            data-testid={card.id}>
            <img className="front-face" src={process.env.REACT_APP_CLOUD_FRONT_URL + card.artImage} alt="Card" />
            <div className="back-face">
                <img
                    src={process.env.REACT_APP_ORIGINAL_URL + back_image}
                    className="back-face-img"
                    alt="Back face"></img>
            </div>
        </Box>
    );
}

export default Card;
